import greekFlag from '../assets/greekFlag.png'
import britishFlag from '../assets/britishFlag.png'
import germanFlag from '../assets/germanFlag.png'
import frenchFlag from '../assets/frenchFlag.png'
import turkishFlag from '../assets/turkishFlag.png'
import bulgarianFlag from '../assets/bulgarianFlag.png'
import serbianFlag from '../assets/serbianFlag.png'
import romanianFlag from '../assets/romanianFlag.png'

export const languages = [
  {id: 'el', name: 'Ελληνικά', image: greekFlag}, 
  {id: 'en', name: 'English', image: britishFlag}, 
  {id: 'de', name: 'Deutsch', image: germanFlag}, 
  {id: 'fr', name: 'Français', image: frenchFlag}, 
  {id: 'tr', name: 'Türkçe', image: turkishFlag},
  {id: 'bg', name: 'български', image: bulgarianFlag},
  {id: 'sr', name: 'Српски', image: serbianFlag},
  {id: 'ro', name: 'Română', image: romanianFlag},
]